const messagesEN = {
    code: "en",
    messages: {
        alpha: (field) => `The ${field} field may only contain alphabetic characters`,
        alpha_num: (field) => `The ${field} field may only contain alpha-numeric characters`,
        alpha_dash: (field) =>
            `The ${field} field may contain alpha-numeric characters as well as dashes and underscores`,
        alpha_spaces: (field) => `The ${field} field may only contain alphabetic characters as well as spaces`,
        between: (field, min, max) => `The ${field} field must be between ${min} and ${max}`,
        confirmed: (field) => `The ${field} field confirmation does not match`,
        digits: (field, length) => `The ${field} field must be numeric and exactly contain ${length} digits`,
        dimensions: (field, width, height) => `The ${field} field must be ${width} pixels by ${height} pixels`,
        email: (field) => `The ${field} field must be a valid email`,
        excluded: (field) => `The ${field} is not a valid value.`,
        ext: (field) => `The ${field} field is not a valid file`,
        image: (field) => `The ${field} field must be an image`,
        integer: (field) => `The ${field} field must be an integer`,
        length: (field, length) => `The ${field} field must be ${length} long`,
        max_value: (field, max) => `The ${field} field must be ${max} or less`,
        max: (field, length) => `The ${field} field may not be greater than ${length} characters`,
        mimes: (field) => `The ${field} field must have a valid file type`,
        min_value: (field, min) => `The ${field} field must be ${min} or more`,
        min: (field, length) => `The ${field} field must be at least ${length} characters`,
        numeric: (field) => `The ${field} field may only contain numeric characters`,
        oneOf: (field) => `The ${field} field is not a valid value`,
        regex: (field) => `The ${field} field format is invalid`,
        required_if: (field) => `The ${field} field is required`,
        required: (field) => `The ${field} field is required`,
        size: (field, size) => `The ${field} field size must be less than ${size}K`,
    },
};

export default messagesEN;



// WEBPACK FOOTER //
// ./src/language/validationMessagesEN.js